import React from "react";

import { Divider, Backdrop, Box, Paper, Modal, Fade, Stack, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";

const ModalContent = styled(Paper)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
}));


class ModalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  reloadPage = () => {
    window.location.reload()
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {

    const { error } = this.state

    if (error) {
      return (
        <Modal open={true} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 500 }}>
          <Fade in={true}>
            <ModalContent sx={{
              width: { xs: '100%', sm: '90%' },
              minWidth: {},
              maxWidth: { sm: '550px' },
              height: { xs: '100%', sm: 'unset' },
              minHeight: {},
              maxHeight: { sm: '90vh' },
            }}>
              <Box position='relative' sx={{ p: 2 }}>
                <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ flex: 1 }}>
                  <Typography>Error</Typography>
                </Stack>
              </Box>
              <Divider />
              <Box p={2}>
                <Typography>Something went wrong while opening modal. We are sorry for inconvenience. Pleaser try reloading page</Typography>
              </Box>
              <Divider />
              <Box p={2}>
                <Stack direction='row' justifyContent="flex-end" alignItems="center" spacing={2}>
                  <Button onClick={this.reloadPage} variant="contained" color="secondary" >Reload</Button>
                </Stack>
              </Box>
            </ModalContent>
          </Fade>
        </Modal >
      );
    } else {
      return this.props.children;
    }
  }
}

export default ModalErrorBoundary;